import { StyleSheet } from '@react-pdf/renderer';
// import { StyleSheet, Font } from '@react-pdf/renderer';

// import FontRegular from './SourceSansPro-Regular.ttf';
// import FontBold from './SourceSansPro-Bold.ttf'

// Font.register({ family: 'SourceSansPro', fonts: [
//   { src: FontRegular },
//   { src: FontBold, fontWeight: 700}
// ]});

const styles = StyleSheet.create({
  page: {
    flexDirection: 'row',
    padding: '20pt',
    // fontFamily: 'SourceSansPro'
  },
  pageLeft: {
    display: 'flex',
    flexDirection: 'column',
    width: '50%',
    paddingRight: '10pt'
  },
  pageRight: {
    display: 'flex',
    flexDirection: 'column',
    width: '50%',
    paddingLeft: '20pt'
  },
  pageWrapper: {
    display: 'flex',
    flexDirection: 'row'
  },
  frontPageHeader: {
    flexDirection: 'row',
    alignItems: 'center',
    height: '60pt',
    marginBottom: '20pt',
    backgroundColor: '#285C4D',
    padding: '15pt',
  },
  frontPageLogo: {
    height: '55pt',
    width: 'auto',
    marginRight: '15pt',
  },
  frontPageTitle: {
    textAlign: 'left',
    fontSize: 22,
    color: 'white',
    fontWeight: 700,
  },
  frontPageInfo: {
    display: 'flex',
    flexDirection: 'column',
    padding: '0 15pt'
  },
  frontPageHeading: {
    fontSize: 14,
    marginBottom: '5pt'
  },
  frontPageValue: {
    fontSize: 24,
    fontWeight: 700,
    marginBottom: '20pt'
  },
  footnote: {
    marginTop: 'auto',
    fontSize: 8
  },
  map: {
    width: '60vw',
    height: 'auto',
  },
  mapLocation: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    fontSize: 8,
    marginVertical: '4pt'
  },
  mapCoordinates: {
    marginLeft: '20pt'
  },
  mapLegendWrapper: {
    backgroundColor: '#f2f2f2',
    display: 'flex',
    flexDirection: 'column',
    padding: '10pt',
    height: '31vh'
  },
  mapLegendTitle: {
    fontSize: 12,
    fontWeight: 700,
    marginBottom: '10pt'
  },
  legendItemsWrapper: {
    display: 'flex',
    flexDirection: 'column',
    flexWrap: 'wrap'
  },
  mapLegend: {
    display: 'flex',
    flexDirection: 'row',
    marginBottom: '15pt',
    marginRight: '30pt',
    alignItems: 'center',
    width: '30%'
  },
  mapLegendIcon: {
    height: '15pt',
    width: '15pt',
    marginRight: '5pt'
  },
  mapLegendText: {
    fontSize: 9,
  },
  mapCompass: {
    borderTopLeftRadius: '15pt',
    borderTopRightRadius: '15pt',
    borderBottomLeftRadius: '15pt',
    borderBottomRightRadius: '15pt',
    backgroundColor: 'white',
    height: '15pt',
    width: '15pt',
    // opacity: 0.8,
    position: 'absolute',
    right: '5pt',
    top: '15pt',
  },
  principleWrapper: {
    display: 'flex',
    flexDirection: 'column',
  },
  principleTitle: {
    fontSize: 12,
    fontWeight: 700,
    marginBottom: '5pt'
  },
  principleTable: {
    display: 'flex',
    flexDirection: 'column',
    marginBottom: '10pt',
    border: '1pt solid #e0e0e0',
    fontSize: 8
  },
  principleTableHeader: {
    display: 'flex',
    flexDirection: 'row',
    height: '25pt',
    backgroundColor: '#6D8D84',
    color: '#ffffff',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '0 5pt'
  },
  principleTableColumn: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  principleTableBody: {
    display: 'flex',
    flexDirection: 'column',
  },
  principleTableRow: {
    display: 'flex',
    flexDirection: 'row',
    padding: '0 5pt',
    height: '25pt',
  },
  assessmentTitle: {
    fontSize: 18,
    marginBottom: '10pt'
  },
  assessmentsWrapper: {
    flexDirection: 'column',
    justifyContent: 'space-evenly',
    alignItems: 'center',
    height: '86vh',
    width: '42vw',
  },
  assessment: {
    display: 'flex',
    flexDirection: 'column',
    paddingLeft: '10pt',
    marginBottom: '20pt',
    // height: '43vh',
  },
  assessmentPrinciple: {
    fontSize: 12,
    fontWeight: 700,
    marginBottom: '5pt'
  },
  criteriaWrapper: {
    display: 'flex',
    flexDirection: 'row',
    fontSize: 8
  },
  criterion: {
    fontWeight: 700
  },
  assessmentResults: {
    display: 'flex',
    flexDirection: 'row',
    width: '40vw',
    marginTop: '15pt'
  },
  resultsLeft: {
    display: 'flex',
    flexDirection: 'column',
    width: '30%',
  },
  resultsRight: {
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    width: '70%',
  },
  assessmentResultsHeading: {
    fontSize: 8,
    marginBottom: '5pt'
  },
  assessmentResultsValue: {
    fontSize: 10,
    fontWeight: 700,
    marginBottom: '10pt'
  },
  criterionDescriptionWrapper: {
    display: 'flex',
    flexDirection: 'column',
    width: '38vw'
  },
  criterionList: {
    display: 'flex',
    flexDirection: 'column'
  },
  criterionItem: {
    marginTop: '5pt',
    marginBottom: '5pt'
  },
  chartView: {
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    height: 'auto',
    width: '100%',
    margin: '15pt 0',
  },
  chart: {
    width: 'auto',
    height: '27vh',
  },
  treeLossLegend: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  chevron: {
    width: 'auto'
  },
  hectarCount: {
    display: 'flex', 
    flexDirection: 'row'
  }
});

export default styles;
